var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18428 29.6167L11.301 25.6667C14.036 29.2117 16.9243 30.8834 20.116 30.8834C23.3076 30.8834 26.1443 29.2617 28.7276 25.7167L33.9443 29.5667C30.1976 34.6334 25.536 37.3167 20.116 37.3167C14.746 37.3167 10.0343 34.6334 6.18428 29.6167ZM19.811 12.5451L10.6926 20.3967L6.48762 15.4834L19.811 3.9834L33.0843 15.4834L28.8293 20.3467L19.811 12.5451Z",
    fill: "url(#paint0_linear_235_1204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_1204",
    x1: 20.0634,
    y1: 3.9834,
    x2: 20.0634,
    y2: 37.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF607E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6783FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo8);
export default __webpack_public_path__ + "static/media/logo8.6657f29cd1c712e6563953ce99a3707f.svg";
export { ForwardRef as ReactComponent };